export default __webpack_public_path__ + "static/media/vacasa.ed68aac0.png";